<script setup lang="ts">
import ApplicationBase from '../ApplicationBase.vue'
import Umsaekjandi from '../Shared/Umsaekjandi.vue'
import Step2 from './Steps/Step2.vue'
import Step3 from './Steps/Step3.vue'
import Step4 from './Steps/Step4.vue'
import Step5 from './Steps/Step5.vue'
import Step6 from './Steps/Step6.vue'
import Step7 from './Steps/Step7.vue'
import PEP from '../Shared/PEP.vue'
import Undirritun from '../Shared/Undirritun.vue'
import ApplicationLanVedlutningBegin from './Steps/ApplicationLanVedlutningBegin.vue'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import { watch } from 'vue'

const steps = [
  { comp: ApplicationLanVedlutningBegin,  titleKey: '' },
  { comp: Umsaekjandi,  titleKey: 'umsokn_umsaekjandi_header' },
  { comp: Step2,        titleKey: 'lan_vedflutning_step2_header' },
  { comp: Step3,        titleKey: 'lan_vedflutning_step3_header' },
  { comp: Step4,        titleKey: 'lan_vedflutning_step4_header' },
  { comp: Step5,        titleKey: 'lan_vedflutning_step5_header' },
  { comp: PEP,          titleKey: 'umsokn_PEP_header' },
  { comp: Step6,          titleKey: 'lan_vedflutning_step6_header' },
  { comp: Step7,          titleKey: 'umsokn_samantekt_header' },
  { comp: Undirritun,   titleKey: 'undirritun_umsokn_header1' },
]

const { umsokn } = useUmsokn()


watch(
  () => umsokn.value,
  () => {
    if (!umsokn.value) return

    if (!umsokn.value.loanInformation) umsokn.value.loanInformation = []
    if (!umsokn.value.coDeptors) umsokn.value.coDeptors = []
    if (!umsokn.value.loanBefore) umsokn.value.loanBefore = []
    if (!umsokn.value.currentDeptorInformation) umsokn.value.currentDeptorInformation = []
    if (!umsokn.value.loantakers) umsokn.value.loantakers = []

    // objects that might come back as null but should exist for binding
    if (!umsokn.value.takeOverLoanInformation) {
      umsokn.value.takeOverLoanInformation = {
        loanNumber: '',
        initialAmount: '',
        mortgage: null,
        issueDate: ''
      }
    }
  }
)

</script>



<template>
  <ApplicationBase :app-id="16" update-key="lan-vedflutning" :steps="steps" />
</template>
